import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue'
import router from './router'
import {Panel} from 'vant';
import {Icon} from 'vant';
import {List} from 'vant';
import {Col, Row} from 'vant';
import {Divider} from 'vant';
import {Image} from 'vant';
import axios from 'axios';
import qs from 'qs';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
Vue.prototype.$qs = qs;

// 使用 Vuex 进行状态管理
Vue.use(Vuex);

Vue.config.productionTip = false;
Vue.use(Panel);
Vue.use(Icon);
Vue.use(List);
Vue.use(Col);
Vue.use(Row);
Vue.use(Divider);
Vue.use(Image);


// 通过 Vue.use 的方式注入 store
const store = new Vuex.Store({
    state: {
        userToken: "",
        userMask:'',
        taxiOrderInfo:'',
        taxiOrderList:'',
        taxiPageTab:'',
        isApply:0
    },
    mutations: {
        setUserToken(state, data) {
            state.userToken = data;
        },
        setUserMask(state, data) {
            state.userMask = data;
        },
        setTaxiOrderInfo(state, data) {
            state.taxiOrderInfo = data;
        },
        setTaxiOrderList(state, data) {
            state.taxiOrderList = data;
        },
        setTaxiPageTab(state,data){
            state.taxiPageTab = data;
        },
        setMaskIsApply(state,data){
            state.isApply = data;
        }
    }
});

Vue.prototype.$store = store;

// 给每个页面设置页面标题
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

// 引入全局 Axios 并进行配置, 配置默认 API 地址， 如果有用户token 自动加入用户 Token
axios.interceptors.request.use(
    config => {
        config.baseURL = process.env.VUE_APP_API_HOST;
        let token = store.state.userToken;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error)});


Vue.prototype.$axios = axios;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');


